import React from 'react'
import { string, arrayOf, number } from 'prop-types'
import T from '../i18n/T'
import s from './BreadcrumbItem.less'

export default function BreadcrumbItem(props) {
  const { labelKey, labelArgs, url, idx } = props
  return (
    <li itemProp="itemListElement" itemScope={true} itemType="https://schema.org/ListItem" className={s.breadcrumbItem}>
      {url ? (
        <a className={s.breadcrumbLink} itemProp="item" href={url}>
          <span itemProp="name">{labelKey && <T id={labelKey} args={labelArgs} />}</span>
        </a>
      ) : (
        <span itemProp="name">{labelKey && <T id={labelKey} args={labelArgs} />}</span>
      )}
      <meta itemProp="position" content={idx} />
    </li>
  )
}

BreadcrumbItem.propTypes = {
  labelKey: string.isRequired,
  labelArgs: arrayOf(string),
  url: string,
  idx: number
}
